import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/authStore";
import { api } from "../../lib/api";
import { useT } from "../../i18n";

const G = "#0891b2";

const PLANS_WITH_ALERTS = ["pro", "ultra"];
// Antes se llamaba PLANS_WITH_TRENDS, pero «Tendencia de precios» salió del menú de
// cliente el 10 sep: la única entrada que usa esta constante es el Comparador.
const PLANS_WITH_PRICES = ["ultra"];
const PLANS_WITH_REPORTS = ["pro", "ultra"];

// ── SVG icon helper ───────────────────────────────────────────────────────────
// All icons: Heroicons v2 outline, 24×24 viewBox, stroke-based
const I = ({ d, d2 }: { d: string; d2?: string }) => (
  <svg
    width="16" height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0 }}
  >
    <path d={d} />
    {d2 && <path d={d2} />}
  </svg>
);

// ── Icon library ──────────────────────────────────────────────────────────────
const Icons = {
  // Inbox — leads / solicitudes de reunión
  inbox: <I d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z" />,
  // Grid 2×2 — dashboard
  grid: <I d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />,

  // Arrow path — cambios / refresh
  arrowPath: <I d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />,

  // Magnifying glass — catálogo / búsqueda
  magnifier: <I d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />,

  // Clock — histórico
  clock: <I d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />,

  // Arrow trending up — predicciones
  trendingUp: <I d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />,

  // Bell — alertas
  bell: <I d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />,

  // Signal / radio waves — radar
  signal: <I d="M9.348 14.651a3.75 3.75 0 010-5.303m5.304 0a3.75 3.75 0 010 5.303m-7.425 2.122a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.808-3.808-9.98 0-13.789m13.788 0c3.808 3.808 3.808 9.981 0 13.79M12 12h.008v.007H12V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />,

  // Beaker — mis productos
  beaker: <I d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />,

  // Shield check — competidores
  shield: <I d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />,

  // Circle stack — fuentes / database
  database: <I d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 2.625c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125m16.5 5.625c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />,

  // Cog 6 tooth — admin / settings
  cog: <I
    d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
    d2="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  />,

  // Globe alt — patrones webs
  globe: <I d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />,

  // Building office — organizaciones
  building: <I d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />,

  // Users — usuarios
  users: <I d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />,

  // Credit card — facturación
  creditCard: <I d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />,

  // Presentation chart line — dashboard global
  chartLine: <I d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605" />,

  // Chart bar square — actividad
  chartBar: <I d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z" />,

  // Table cells — dashboard x fuente
  tableCells: <I d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m0-3.75c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m0 1.5h7.5M3.375 15.75h7.5" />,

  // Megaphone — avisos
  megaphone: <I d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46" />,

  // Document text — informes
  documentText: <I d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />,

  // Calendar days — calendario regulatorio
  calendar: <I d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />,

  // Scale / balanza — comparador de precios
  scale: <I d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 01-2.031.352 5.988 5.988 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 01-2.031.352 5.989 5.989 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971z" />,

  // Tag / bookmark — version badge
  tag: <I d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z M6 6h.008v.008H6V6z" />,
};

// Lock closed — Heroicons v2 outline (planes superiores)
const LockIcon = (
  <svg
    width="14" height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0 }}
  >
    <path d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);

// Mapeo ruta gateada → query param de /upgrade
const UPGRADE_FEATURE: Record<string, string> = {
  "/alerts": "alerts",
  "/trends": "trends",
  "/prices": "prices",
  "/reports": "reports",
};

// ── Nav item type ─────────────────────────────────────────────────────────────
type NavItem =
  | { kind: "link"; to: string; label: string; icon: React.ReactNode; adminOnly: boolean; superadminOnly?: boolean; requiredPlans?: string[] }
  | { kind: "section"; label: string; adminOnly: boolean; superadminOnly?: boolean };

// ── Superadmin navigation ─────────────────────────────────────────────────────
const superadminNav: NavItem[] = [
  { kind: "section", label: "Monitorización",      adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/dashboard",         label: "Panel de Control",   icon: Icons.chartLine,  adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/dashboard-fuentes", label: "Estado del sistema", icon: Icons.tableCells, adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/servicio",          label: "Nivel de servicio",  icon: Icons.clock,      adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/changes",                      label: "Eventos",            icon: Icons.arrowPath,  adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/history",                      label: "Histórico",          icon: Icons.clock,      adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/radar",                        label: "Radar Regulatorio",  icon: Icons.signal,     adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/trends",                       label: "Tendencia de precios", icon: Icons.trendingUp, adminOnly: false, superadminOnly: true },
  { kind: "section", label: "Comunicación",        adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/avisos",            label: "Avisos",             icon: Icons.megaphone,  adminOnly: false, superadminOnly: true },
  { kind: "section", label: "Clientes",            adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/leads",             label: "Leads",              icon: Icons.inbox,      adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin",                   label: "Organizaciones",     icon: Icons.building,   adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/usuarios",          label: "Usuarios",           icon: Icons.users,      adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/facturacion",       label: "Facturación",        icon: Icons.creditCard, adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/contratos",          label: "Contratos",          icon: Icons.tag,        adminOnly: false, superadminOnly: true },
  { kind: "section", label: "Técnico",             adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/superadmin/actividad",         label: "Actividad",          icon: Icons.chartBar,   adminOnly: false, superadminOnly: true },
  { kind: "link", to: "/admin/probes",                 label: "Patrones webs",      icon: Icons.globe,      adminOnly: false, superadminOnly: true },
];

// ── Regular user navigation ───────────────────────────────────────────────────
// `label` es una clave i18n (nav.*); se resuelve con t() al renderizar.
const nav: NavItem[] = [
  { kind: "link", to: "/dashboard",   label: "nav.dashboard",   icon: Icons.grid,      adminOnly: false },
  { kind: "link", to: "/analytics",   label: "nav.analytics",   icon: Icons.chartLine, adminOnly: false },
  { kind: "link", to: "/changes",     label: "nav.changes",     icon: Icons.arrowPath, adminOnly: false },
  { kind: "link", to: "/history",     label: "nav.history",     icon: Icons.clock,     adminOnly: false },
  { kind: "link", to: "/prices",      label: "nav.prices",      icon: Icons.scale,      adminOnly: false, requiredPlans: PLANS_WITH_PRICES },
  // «Tendencia de precios» NO aparece en el menú de cliente (10 sep 2026). Verificado contra los datos
  // de producción: el panel del modelo sólo cubre 144 de las 1.294 agrupaciones homogéneas —las de
  // genéricos maduros, que llevan años apareciendo en cada publicación de precios menores— y ninguna
  // organización compite en ellas: Italfarmaco coincidiría en 1 de sus 72 y el resto en ninguna. La
  // pantalla saldría vacía para todos. Sigue viva como herramienta de superadmin (`superadminNav`),
  // que es de donde venía: ahí sí sirve para ver hacia dónde se mueve el mercado de genéricos.
  { kind: "link", to: "/alerts",      label: "nav.alerts",      icon: Icons.bell,      adminOnly: false, requiredPlans: PLANS_WITH_ALERTS },

  { kind: "section", label: "nav.intelligence", adminOnly: false },
  { kind: "link", to: "/radar",        label: "nav.radar",     icon: Icons.signal,       adminOnly: false },
  { kind: "link", to: "/calendar",     label: "nav.calendar",  icon: Icons.calendar,     adminOnly: false },
  { kind: "link", to: "/reports",      label: "nav.reports",   icon: Icons.documentText, adminOnly: false, requiredPlans: PLANS_WITH_REPORTS },

  { kind: "section", label: "nav.configuration", adminOnly: false },
  { kind: "link", to: "/catalog",     label: "nav.catalog",     icon: Icons.magnifier, adminOnly: false },
  { kind: "link", to: "/products",    label: "nav.products",    icon: Icons.beaker,    adminOnly: false },
  { kind: "link", to: "/competitors", label: "nav.competitors", icon: Icons.shield,    adminOnly: false },
  { kind: "link", to: "/sources",     label: "nav.sources",     icon: Icons.database,  adminOnly: false },
  // Severidad por hito y relación, editable por el admin de la org (catálogo 3.9, 28 sep 2026)
  { kind: "link", to: "/severity",    label: "nav.severity",    icon: Icons.scale,     adminOnly: false },

  { kind: "section", label: "nav.administration", adminOnly: false },
  { kind: "link", to: "/admin",         label: "nav.users",         icon: Icons.users, adminOnly: true },
  { kind: "link", to: "/admin/activity", label: "nav.auditLog",     icon: Icons.documentText, adminOnly: true },
  { kind: "link", to: "/profile",       label: "nav.profile",       icon: Icons.cog,   adminOnly: false },
  { kind: "link", to: "/notifications", label: "nav.notifications", icon: Icons.bell,  adminOnly: false },
];

// ── Component ─────────────────────────────────────────────────────────────────
type SidebarProps = {
  isMobile?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
};

export default function Sidebar({ isMobile = false, isOpen = true, onClose }: SidebarProps) {
  const t = useT();
  const role = useAuthStore(s => s.user?.role);
  const plan = useAuthStore(s => s.user?.plan);
  const impersonating = useAuthStore(s => s.impersonating);
  const orgName = useAuthStore(s => s.user?.organization_name);
  const logoUrl = useAuthStore(s => s.user?.logo_url);
  const [version, setVersion] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get<{ current_version: string }>("/version")
      .then(d => setVersion(d.current_version))
      .catch(() => {});
  }, []);

  const mobileStyle: React.CSSProperties = isMobile ? {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100%",
    zIndex: 400,  // sobre el TopBar (300) y su backdrop (350)
    transform: isOpen ? "translateX(0)" : "translateX(-100%)",
    transition: "transform 0.25s ease",
    boxShadow: isOpen ? "4px 0 24px rgba(0,0,0,0.25)" : "none",
  } : {};

  return (
    <nav style={{
      width: 224,
      background: "var(--clr-sidebar)",
      backdropFilter: "var(--clr-blur)",
      WebkitBackdropFilter: "var(--clr-blur)",
      borderRight: "1px solid var(--clr-sidebar-border)",
      color: "var(--clr-text)",
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      position: "relative",
      zIndex: 1,
      ...mobileStyle,
    }}>
      {/* Logo */}
      <Link
        to={role === "superadmin" && !impersonating ? "/superadmin/dashboard" : "/dashboard"}
        title={t("nav.goToDashboard")}
        onClick={isMobile ? onClose : undefined}
        style={{ display: "block", padding: "1.25rem 1rem 1rem", borderBottom: "1px solid var(--clr-sidebar-border)", textDecoration: "none", position: "relative" }}
      >
        {isMobile && (
          <button
            onClick={e => { e.preventDefault(); onClose?.(); }}
            style={{
              position: "absolute", top: 12, right: 12,
              background: "transparent", border: "none", cursor: "pointer",
              color: "var(--clr-text4)", fontSize: "1.2rem", lineHeight: 1,
              padding: 4,
            }}
            aria-label={t("nav.closeMenu")}
          >✕</button>
        )}
        <div style={{ background: "var(--clr-logo-bg)", borderRadius: "var(--clr-logo-radius)", padding: "var(--clr-logo-padding)", transition: "all 0.2s", cursor: "pointer" }}>
          {logoUrl ? (
            <>
              <img src={logoUrl} alt={orgName || "Logo"} style={{ width: "100%", maxWidth: 170, maxHeight: 52, display: "block", objectFit: "contain", filter: "var(--clr-logo-filter)" }} />
              <div style={{ marginTop: 6, fontSize: "0.6rem", color: "var(--clr-logo-text)", letterSpacing: "1px", textTransform: "uppercase", opacity: 0.6 }}>
                powered by HelixScan
              </div>
            </>
          ) : (
            <>
              <img src="/helixscan-logo.png" alt="HelixScan" style={{ width: "100%", maxWidth: 170, display: "block", objectFit: "contain", filter: "var(--clr-logo-filter)" }} />
              <div style={{ marginTop: 6, fontSize: "0.65rem", color: "var(--clr-logo-text)", letterSpacing: "0.5px", textTransform: "uppercase", lineHeight: 1.4 }}>
                {t("nav.tagline")}
              </div>
            </>
          )}
        </div>
      </Link>

      {/* Nav links */}
      <div style={{ flex: 1, padding: "0.75rem 0.5rem", overflowY: "auto" }}>
        {(role === "superadmin" && !impersonating ? superadminNav : nav)
          .filter(item => {
            if (role === "superadmin" && !impersonating) return true;
            if (item.superadminOnly) return role === "superadmin";
            if (item.adminOnly) return role === "admin" || role === "superadmin";
            return true;
          })
          .map((item, i) => {
            if (item.kind === "section") {
              return (
                <div
                  key={`sec-${i}`}
                  style={{
                    margin: "20px 0.875rem 7px",
                    fontSize: "0.64rem",
                    fontWeight: 600,
                    letterSpacing: "1.4px",
                    textTransform: "uppercase",
                    color: "var(--clr-text4)",
                  }}
                >
                  {t(item.label)}
                </div>
              );
            }
            // Item gateado por plan: visible pero bloqueado → lleva a /upgrade
            const locked =
              item.requiredPlans != null &&
              role !== "superadmin" &&
              !(plan != null && item.requiredPlans.includes(plan));

            if (locked) {
              const featureParam = UPGRADE_FEATURE[item.to];
              const upgradeTo = featureParam ? `/upgrade?feature=${featureParam}` : "/upgrade";
              const requiredPlanName = (item.requiredPlans?.[0] ?? "").toUpperCase();
              return (
                <Link
                  key={item.to}
                  to={upgradeTo}
                  title={t("nav.availableInPlan", { plan: requiredPlanName })}
                  data-tour={item.to}
                  onClick={isMobile ? onClose : undefined}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "0.55rem 0.75rem",
                    borderRadius: 12,
                    color: "var(--clr-text4)",
                    background: "transparent",
                    textDecoration: "none",
                    fontSize: "0.85rem",
                    fontWeight: 400,
                    marginBottom: 2,
                    transition: "all 0.15s",
                  }}
                >
                  <span style={{ opacity: 0.65, display: "inline-flex", alignItems: "center", flexShrink: 0 }}>
                    {item.icon}
                  </span>
                  <span style={{ flex: 1, minWidth: 0 }}>{t(item.label)}</span>
                  <span style={{ opacity: 0.7, display: "inline-flex", alignItems: "center", flexShrink: 0 }}>
                    {LockIcon}
                  </span>
                </Link>
              );
            }

            return (
              <NavLink
                key={item.to}
                to={item.to}
                end
                data-tour={item.to}
                onClick={isMobile ? onClose : undefined}
                style={({ isActive }) => ({
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "0.55rem 0.75rem",
                  borderRadius: 12,
                  color: isActive ? "var(--clr-org-primary)" : "var(--clr-nav-text)",
                  // Píldora tintada del color de la marca para el item activo
                  background: isActive ? "var(--clr-nav-active-bg)" : "transparent",
                  boxShadow: isActive ? "inset 0 1px 0 rgba(255,255,255,0.4)" : "none",
                  textDecoration: "none",
                  fontSize: "0.85rem",
                  fontWeight: isActive ? 600 : 500,
                  marginBottom: 2,
                  transition: "background 0.15s, color 0.15s, box-shadow 0.15s",
                })}
              >
                <span style={{ opacity: 0.65, display: "inline-flex", alignItems: "center", flexShrink: 0 }}>
                  {item.icon}
                </span>
                {t(item.label)}
              </NavLink>
            );
          })}
      </div>

      {/* Version badge */}
      {version && (
        role === "superadmin" ? (  // detalle de versiones: solo superadmin
          <button
            onClick={() => { navigate("/changelog"); onClose?.(); }}
            title={t("nav.versionHistory")}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "0.65rem",
              color: "var(--clr-text4)",
              letterSpacing: "0.5px",
              display: "flex",
              alignItems: "center",
              gap: 6,
              background: "transparent",
              border: "none",
              cursor: "pointer",
              width: "100%",
              textAlign: "left",
              transition: "color 0.15s",
            }}
            onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = G}
            onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = "var(--clr-text4)"}
          >
            <span style={{ opacity: 0.5, display: "inline-flex" }}>{Icons.tag}</span>
            <span>{version}</span>
          </button>
        ) : (
          <div style={{
            padding: "0.5rem 1rem",
            fontSize: "0.65rem",
            color: "var(--clr-text4)",
            letterSpacing: "0.5px",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}>
            <span style={{ opacity: 0.5, display: "inline-flex" }}>{Icons.tag}</span>
            <span>{version}</span>
          </div>
        )
      )}

    </nav>
  );
}
